module.exports = __webpack_public_path__ + "static/media/ecg.f2d047ca.svg";